$(document).ready(function () {

    const $images = $('.js-why-images-slider');
    const $text   = $('.js-why-text-slider');

    const $prevBtn = $('.js-why-prev');
    const $nextBtn = $('.js-why-next');

    // INIT SLICK
    $images.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        asNavFor: '.js-why-text-slider'
    });

    $text.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        asNavFor: '.js-why-images-slider'
    });

    // NAV BUTTONS
    $prevBtn.on('click', () => $images.slick('slickPrev'));
    $nextBtn.on('click', () => $images.slick('slickNext'));

    // FUNCTION TO UPDATE DISABLED STATES
    function updateNavButtons(currentSlide, totalSlides) {
        // First slide
        if (currentSlide === 0) {
            $prevBtn.addClass('disabled');
        } else {
            $prevBtn.removeClass('disabled');
        }

        // Last slide
        if (currentSlide === totalSlides - 1) {
            $nextBtn.addClass('disabled');
        } else {
            $nextBtn.removeClass('disabled');
        }
    }

    // INITIAL STATE
    const totalSlides = $images.find('.slick-slide').not('.slick-cloned').length;

    updateNavButtons(0, totalSlides);

    // LISTEN FOR SLIDE CHANGE
    $images.on('afterChange', function (event, slick, currentSlide) {
        updateNavButtons(currentSlide, slick.slideCount);
    });





    const $slider = $('.about__gallery-track');
    let isDragging = false;
    let lastX = 0;
    let lastScrollLeft = 0;

    // Disable native image/link dragging
    $slider.on('dragstart', 'img, a', function (e) {
        e.preventDefault();
    });

    function getPageX(e) {
        if (e.type.startsWith('touch')) {
            return e.originalEvent.touches[0].pageX;
        }
        return e.pageX;
    }

    // ----- START DRAG -----
    $slider.on('mousedown', function (e) {
        if (e.button !== 0) return; // left click only

        isDragging = true;
        lastX = e.pageX;
        lastScrollLeft = $slider.scrollLeft();

        $slider.addClass('is-grabbing');
        e.preventDefault();
    });

    $slider.on('touchstart', function (e) {
        isDragging = true;
        lastX = getPageX(e);
        lastScrollLeft = $slider.scrollLeft();

        $slider.addClass('is-grabbing');
    });

    // ----- END DRAG -----
    $(document).on('mouseup touchend touchcancel', function () {
        if (!isDragging) return;
        isDragging = false;
        $slider.removeClass('is-grabbing');
    });

    // ----- MOVE -----
    $(document).on('mousemove touchmove', function (e) {
        if (!isDragging) return;

        // if mousemove but no button pressed anymore, stop
        if (e.type === 'mousemove' && e.buttons === 0) {
            isDragging = false;
            $slider.removeClass('is-grabbing');
            return;
        }

        e.preventDefault();

        const currentX = getPageX(e);
        const deltaX = currentX - lastX;          // movement since last frame
        lastX = currentX;

        // 1:1 mapping feels smooth; tweak multiplier if you want faster/slower
        $slider.scrollLeft($slider.scrollLeft() - deltaX);
    });
});